import { ACCOUNT_CONFIG } from "../account/config"
import { CORE_BOOKMARKS_CONFIG } from "../core-bookmarks/config"
import {
  GUTENBERG_FRENCH_ROUTES_CONFIG,
  GUTENBERG_ROUTES_CONFIG,
} from "../gutenberg/config"
import { IS_AUTH } from "../modules/auth"
import { SELECT_CORRECT_TRANSLATION_CONFIG } from "../select-correct-translation/config"
import { SELECT_CORRECT_CONFIG } from "../select-correct/config"
import { SORTABALLS_CHALLENGES_CONFIG } from "../sortaballs-challenges/config"
import { SPEAK_WORDS_OF_SENTENCE_CONFIG } from "../speak-words-of-sentence/config"
import { SPEED_READER_CONFIG } from "../speed-reader/config"
import {
  TRANSLATE_A_CONFIG,
  TRANSLATE_B_CONFIG,
  TRANSLATE_C_CONFIG,
  TRANSLATE_CONFIG,
} from "../TranslateIt/config"
import { WRITE_CODE_CONFIG } from "../write-code/config"
import { createConfig, lazyRoute, type Route } from "./config-utils"
import { WHEN } from "./constants"

const BuildShortSentencesApp = lazyRoute(
  ()=> import("../build-short-sentences/BuildShortSentencesApp"),
  "BuildShortSentencesApp",
)
const DenVsDemApp = lazyRoute(
  ()=> import("../den-vs-dem/DenVsDemApp"),
  "DenVsDemApp",
)
const DontHitItApp = lazyRoute(
  ()=> import("../dont-hit-it/DontHitItApp"),
  "DontHitItApp",
)
const RevealItApp = lazyRoute(
  ()=> import("../reveal-it/RevealItApp"),
  "RevealItApp",
)
const SelectCorrectHaveYouSeenItApp = lazyRoute(
  ()=> import("../have-you-seen-it/SelectCorrectHaveYouSeenItApp"),
  "SelectCorrectHaveYouSeenItApp",
)
const RememberSequenceApp = lazyRoute(
  ()=> import("../remember-sequence/RememberSequenceApp"),
  "RememberSequenceApp",
)
const SelectCorrectWordApp = lazyRoute(
  ()=> import("../select-correct-word/SelectCorrectWordApp"),
  "SelectCorrectWordApp",
)
const SelectPoemRhymeWordApp = lazyRoute(
  ()=> import("../select-poem-rhyme-word/SelectPoemRhymeWordApp"),
  "SelectPoemRhymeWordApp",
)
const ShortSentencesApp = lazyRoute(
  ()=> import("../short-sentences/ShortSentencesApp"),
  "ShortSentencesApp",
)

export const HAVE_YOU_SEEN_IT_CONFIG = {
  browserTitle: "Have You Seen It",
  component: SelectCorrectHaveYouSeenItApp,
  key: "have-you-seen-it",
  label: "Have You Seen It",
  route: "/have-you-seen-it",
}
const SELECT_CORRECT_WORD_CONFIG = createConfig({
  component: SelectCorrectWordApp,
  key: "select-correct-word",
  label: "Select Correct Word",
})
const REMEMBER_SEQUENCE_CONFIG = {
  browserTitle: "Remember Sequence",
  component: RememberSequenceApp,
  key: "remember-sequence",
  label: "Remember Sequence",
  route: "/remember-sequence",
}
const SELECT_POEM_RHYME_WORD_CONFIG = createConfig({
  component: SelectPoemRhymeWordApp,
  key: "select-poem-rhyme-word",
  label: "Select Poem Rhyme Word",
  when: WHEN,
})

const SHORT_SENTENCES_CONFIG = createConfig({
  component: ShortSentencesApp,
  key: "short-sentences",
  label: "Short sentences pairs",
  when: WHEN,
})

const BUILD_SHORT_SENTENCES_CONFIG = createConfig({
  component: BuildShortSentencesApp,
  key: "build-short-sentences",
  label: "Build Short Sentences",
  when: WHEN,
})

const DONT_HIT_IT_CONFIG = {
  browserTitle: "Don't Hit It",
  component: DontHitItApp,
  key: "dont-hit-it",
  label: "Don't Hit It | DE",
  route: "/dont-hit-it",
}

const REVEAL_IT_CONFIG = {
  browserTitle: "Reveal It",
  component: RevealItApp,
  key: "reveal-it",
  label: "Reveal It",
  route: "/reveal-it",
}

const DEN_VS_DEM_CONFIG: null | Route = WHEN
  ? {
      browserTitle: "Den vs Dem",
      component: DenVsDemApp,
      key: "den-vs-dem",
      label: "Den vs Dem",
      language: "french",
      route: "/den-vs-dem",
    }
  : null

export const MAIN_APPLICATIONS_ROUTES_CONFIG_SOURCE: (null | Route)[] = [
  ...(IS_AUTH ? [SORTABALLS_CHALLENGES_CONFIG] : []),
  SPEED_READER_CONFIG,
  HAVE_YOU_SEEN_IT_CONFIG,
  GUTENBERG_ROUTES_CONFIG,
  GUTENBERG_FRENCH_ROUTES_CONFIG,
  SELECT_CORRECT_CONFIG,
  SELECT_CORRECT_WORD_CONFIG,
  SPEAK_WORDS_OF_SENTENCE_CONFIG,
  TRANSLATE_CONFIG,
  REMEMBER_SEQUENCE_CONFIG,
  DONT_HIT_IT_CONFIG,
  REVEAL_IT_CONFIG,
  WRITE_CODE_CONFIG,
]

export const SECONDARY_APPLICATIONS_ROUTES_CONFIG_SOURCE: (null | Route)[] = [
  CORE_BOOKMARKS_CONFIG,
  DEN_VS_DEM_CONFIG,
  SHORT_SENTENCES_CONFIG,
  BUILD_SHORT_SENTENCES_CONFIG,
  SELECT_POEM_RHYME_WORD_CONFIG,
  SELECT_CORRECT_TRANSLATION_CONFIG,
  TRANSLATE_A_CONFIG,
  TRANSLATE_B_CONFIG,
  TRANSLATE_C_CONFIG,
  ACCOUNT_CONFIG,
]

export const ALL_APPLICATIONS_ROUTES_CONFIG: Route[] = [
  ...MAIN_APPLICATIONS_ROUTES_CONFIG_SOURCE,
  ...SECONDARY_APPLICATIONS_ROUTES_CONFIG_SOURCE,
].filter((x): x is Route=> x !== null)
